import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

import LinearGradient from 'react-native-linear-gradient';
import {createShimmerPlaceholder} from 'react-native-shimmer-placeholder';
import {css} from 'styled-components/native';

const ShimmerPlaceHolder = createShimmerPlaceholder(LinearGradient);

export const Grid = styled.View``;
export const Row = styled.View`
  flex-direction: row;
  margin-top: ${RFValue(12)}px;
`;

interface ColumnPosition {
  right?: boolean;
}

export const Item = styled.View<ColumnPosition>`
  width: 50%;
  flex: 1;
  margin-right: ${RFValue(6)}px;

  ${({right}) =>
    right &&
    css`
      margin-right: 0px;
      margin-left: ${RFValue(6)}px;
    `}
`;

export const ItemImage = styled(ShimmerPlaceHolder)`
  height: ${RFValue(45)}px;
  width: 100%;
  border-radius: ${RFValue(8)}px;
  border: 1px solid ${({theme}) => theme.colors.border_light};
  justify-content: center;
  background-color: ${({theme}) => theme.colors.shape};
  align-items: center;
`;
